import React from "react";
import { Link } from "react-router-dom";

import {
  AuthWrapper,
  FormWrapper,
  ContentLogin,
  ImageWrapper,
  Form,
  ConfirmWrapp,
  LinkWrap,
  EmptyColumn,
} from "../../style/Auth";

import logo from "../../images/ic_logo.svg";
import Button from "../../components/button/index";

const SubscriptionExpired = () => (
  <AuthWrapper>
    <FormWrapper>
      <ContentLogin>
        <EmptyColumn />
        <Form as="div">
          <a href="/">
            <img className="logo" src={logo} alt="Logo" />
          </a>
          <h1>Your subscription has expired</h1>
          <p>
            To keep using SmrtStats Player, renew your subscription. We'll pick
            up right where you left off.
          </p>
          <ConfirmWrapp>
            <Link to="/subscription/upgrade" style={{ textDecoration: "none" }}>
              <Button
                title="Renew subscription"
                size="full"
                sizeResponse="full"
                type="button"
              />
            </Link>
          </ConfirmWrapp>
        </Form>
        <LinkWrap>
          <h3>
            <Link to="/login">Log in with a different account</Link>
          </h3>
        </LinkWrap>
      </ContentLogin>
    </FormWrapper>
    <ImageWrapper />
  </AuthWrapper>
);

export default SubscriptionExpired;
